import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CustomValidatorsComponent } from './custom-validators.component';
import { T2TemplateBasicComponent } from 'app/trip2-theme/components/t2-template-basic/t2-template-basic.component';

const routes: Routes = [
  { path: 'pages', component: T2TemplateBasicComponent,
    children: [
      { path: 'custom-validators',
        children: [
          { path: 'examples', component: CustomValidatorsComponent, data: { title: 'examples'} },
        ]
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class CustomValidatorsRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/custom-validators/custom-validators-routing.module.ts